import * as React from "react";

export function renderSuffix(suffix: React.ReactNode): React.ReactNode {
    if (typeof suffix === "string") {
        const leadingSpaceCharCount = /^( +)/.exec(suffix)?.[0]?.length ?? 0;
        if (leadingSpaceCharCount > 0) {
            return <span style={{ marginLeft: leadingSpaceCharCount * 4 }}>{suffix}</span>;
        }
    }
    return suffix;
}

export function renderPrefix(prefix: React.ReactNode): React.ReactNode {
    if (typeof prefix === "string") {
        const leadingSpaceCharCount = /^( +)/.exec(prefix)?.[0]?.length ?? 0;
        if (leadingSpaceCharCount > 0) {
            return <span style={{ marginLeft: leadingSpaceCharCount * 4 }}>{prefix}</span>;
        }
    }
    return prefix;
}
